export default "__VITE_ASSET__CkZJxJ2T__"